module.exports = __webpack_public_path__ + "static/media/LT2.a708794d.jpg";